<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="mb-4">
                <button class="btn btn-success btn-sm" (click)="onExportReport()">Export Report to Excel</button>
            </div>
            <div class="d-flex justify-content-end mb-3 w-50">
                <input type="text" [(ngModel)]="searchText" placeholder="{{ 'SEARCH' | translate }}" (ngModelChange)="changeSearch($event)" class="form-control">
            </div>
            <div class="form-group row mb-3" [formGroup]="paramForm">
                <div class="col-md-3">
                    <app-select-academic-year-only
                        (academicYearChanged)="onChangeAcademicYear($event)">
                    </app-select-academic-year-only>
                </div>
                <div class="col-md-3">
                    <app-select-school-level-relation-v2
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        (schoolLevelRelationChanged)="onChangeSchoolLevel($event)"
                        [isDisabled]="!this.paramForm.get('academic_year')?.value">
                    </app-select-school-level-relation-v2>
                </div>
                <div class="col-md-3">
                    <app-select-school-program
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        [school_location_id]="this.paramForm.get('school_location_id')?.value"
                        [isDisabled]="!this.paramForm.get('school_location_id')?.value"
                        (schoolProgramChanged)="onChangeSchoolProgram($event)">
                    </app-select-school-program>
                </div>
                <div class="col-md-3">
                    <ng-select
                        [items]="yearLevelRelations"
                        (change)="onChangeYearLevel($event)"
                        bindLabel="description"
                        bindValue="year_level_id"
                        formControlName="year_level_id"
                        placeholder="Select year level"
                        class="selector-style">
                        <ng-template ng-option-tmp let-item="item">
                            <div class="custom-option-style">
                                {{ item.description }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <table mat-table
                [dataSource]="reportData" multiTemplateDataRows
                >
                <colgroup>
                    <col style="width: 20%;">
                    <col style="width: 12%;">
                    <col style="width: 18%;">
                    <col style="width: 15%;">
                    <col style="width: 35%;">
                </colgroup>
                <ng-container matColumnDef="student_name" (click)="onSort('student_name')">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'STUDENT_NAME' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position">
                        {{element.student_name || '-'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="nis">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'NIS' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position">
                        {{element.nis || '-'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="class_name" (click)="onSort('class_name')">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'CLASS_NAME' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position">
                        {{element.class_name || '-'}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="total_participated">
                    <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'TOTAL_PARTICIPATED' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position">
                        {{element.total_participated}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="participated">
                    <th mat-header-cell *matHeaderCellDef> {{ 'ACTIVITY_NAME' | translate }} </th>
                    <td mat-cell *matCellDef="let element" class="example-element-position" style="display: flex !important; flex-direction: column !important;">
                        <ng-container *ngIf="element.participated?.length; else noActivity">
                            <div class="p-1 bg-light text-dark border me-1 mb-1 text-start rounded" *ngFor="let activity of element.participated">
                                {{ activity.activity_name }}
                            </div>
                        </ng-container>
                        <ng-template #noActivity>-</ng-template>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row"></tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell p-2" [attr.colspan]="columnsToDisplay.length" *ngIf="!loading">
                        No report data
                    </td>
                </tr>
            </table>
            <mat-paginator *ngIf="reportData.length > 0"
                [pageSize]="15"
                (page)="onChangePage($event)"
                [pageIndex]="currentPage - 1"
                [length]="total">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>
